












































import Vue from 'vue'
import {ExtranetServiceProxy, GatewayExtranetServiceProxy} from '@/service-proxies/app-v2/extranet.service-proxies'

import MachineEditConnectFeature from './edit-connect-feature.vue'
import {ExtranetParamSettingServiceProxy} from "@/service-proxies/app-v2/iot-extranet.service-proxies";

const extranetSrvProxy = new ExtranetServiceProxy()
const gatewayExtranetSrvProxy = new GatewayExtranetServiceProxy();
const paramSettingProxy = new ExtranetParamSettingServiceProxy()

export default Vue.extend({
  components: {
    MachineEditConnectFeature
  },
  props: {},
  data() {
    return {
      extranetSetting: {},
      loading: false,
      workStationId: undefined,
      configList: [],
      columns: [
        {
          title: this.$t('actions'),
          dataIndex: 'action',
          width: 150,
          ellipsis: true,
          scopedSlots: { customRender: 'action' }
        },
        {
          title: this.$t('page_ops_machine_connect_virtualIp'),
          dataIndex: 'virtualIp',
          width: 150
        },
        {
          title: this.$t('page_ops_machine_connect_virtualPort'),
          dataIndex: 'virtualPort',
          width: 100
        },
        {
          title: this.$t('page_ops_machine_connect_machineIp'),
          dataIndex: 'ip',
          width: 150
        },
        {
          title: this.$t('page_ops_machine_connect_machinePort'),
          dataIndex: 'port',
          width: 100
        },
        {
          title: this.$t('page_ops_machine_connect_transportProtocol'),
          dataIndex: 'protocol',
          width: 100
        },
        {
          title: this.$t('page_ops_machine_connect_applicationProtocol'),
          dataIndex: 'appProtocol',
          width: 100
        }
      ]
    }
  },
  mounted() {
    paramSettingProxy.getCurrentExtranetParamSetting()
        .then(res=>{
          this.extranetSetting={
            max: res.max,
            editEnable: res.editEnable,
            deleteEnable: res.deleteEnable
          }
        })
  },
  computed: {
    addEnable: function(){
      const listSize = (this.configList || []).length;
      return listSize < (this.extranetSetting.max || 0);
    },
    editEnable: function(){
      return this.extranetSetting && this.extranetSetting.editEnable;
    },
    deleteEnable: function (){
      return this.extranetSetting && this.extranetSetting.deleteEnable;
    }
  },
  methods: {
    show(workStationId) {
      this.workStationId = workStationId
      if (workStationId) {
        this.refresh()
      } else {
        this.configList = []
      }
    },
    openEditConnect(info) {
      if(!this.addEnable){
        this.$message.error('不允许添加');
        return;
      }
      this.$refs.editConnectFeature.open(this.workStationId, info)
    },
    resetConnect(info) {
      gatewayExtranetSrvProxy.resetExtranetConfig(info.id)
        .then(res=>{
          this.refresh();
        })
    },
    refresh() {
      this.loading = true
      extranetSrvProxy
        .queryDeviceExtranetConfigOutList(this.workStationId)
        .then((res) => {
          this.configList = res
          console.log('config list', this.configList)
        })
        .finally(() => (this.loading = false))
    },
    remove(record) {
      extranetSrvProxy.delDeviceExtranetConfig(record.id).then((res) => {
        this.$message.error(this.$t('delete_success'))
        this.refresh()
      })
    }
  }
})
